import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "cut-end" }
const _hoisted_2 = { class: "cut-end_greeting" }
const _hoisted_3 = { class: "greeting-emoji" }
const _hoisted_4 = ["src"]
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "statistic flex-row justify-evenly" }
const _hoisted_7 = { class: "num common-color" }
const _hoisted_8 = { class: "num num-color" }
const _hoisted_9 = ["src"]
const _hoisted_10 = ["src"]
const _hoisted_11 = ["src"]
const _hoisted_12 = ["src"]
const _hoisted_13 = {
  key: 3,
  class: "end flex-row justify-center"
}

import mqttServer from "@/js/mqtt"
// import http from "@/js/http";
import { onBeforeMount, onMounted, ref } from "vue"
import { useRoute } from "vue-router"
import store from "@/js/store"
import { getBrandImageUrl } from "@/js/brandImages"
import pagesQueue from "@/js/pagesQueue"
import { modalController } from "@ionic/vue"


export default /*@__PURE__*/_defineComponent({
  __name: 'CutBoxEndModal',
  props: ["yesNum", "notNum", "selectYesIndex", "selectNotIndex"],
  setup(__props) {

const route = useRoute()
const studentInfo = ref()
const props = __props
const storeData = ref()

const instructData = ref({
  project: "lxll",
  page: "teachIndex",
  module: "CutBoxEndModal",
  userType: 1,
  data: null,
  fn: "",
  param: null,
  timestamp: " ",
})

onMounted(() => {
  mqttServer.onMqttMessage(instructData.value.module, onMessageReceived)
})

function onMessageReceived(msg: any) {
  if (msg.fn == "continuePractiseSync") {
    continuePractiseSync()
  }
}

// status - 普通练习:common 继续练习:continue 回到智阅:AIReading
let sta: string

// 结束练习并创建抗遗忘 回到首页
async function endTheExercise() {
  const id = storeData.value.courseTypeId || "练习"
  switch (id) {
    case 16: // AI智阅
      sta = "TO_HOME"
      break
    case 3: // 阅读理解
      sta = "TO_HOME"
      break
    case 1: // 单词识记
      sta = "TO_HOME"
      break
    case "练习":
      sta = "TO_HOME"
      break
    default:
      break
  }
  await modalController.dismiss({ status: sta })
}

// 继续练习 回到九阶岛
async function continuePractise() {
  mqttServer
    .pushMsg(instructData.value, {
      params: [],
      fn: "continuePractiseSync",
      msgType: "function",
    })
    .then(() => {
      continuePractiseSync()
    })
}

async function continuePractiseSync() {
  const id = storeData.value.courseTypeId || "练习"
  switch (id) {
    case 16: // AI智阅
      sta = "TO_ARTICLE"
      break
    case 3: // 阅读理解
      sta = "TO_ARTICLE"
      break
    case 1: // 单词识记
      sta = "Nine"
      break
    case "练习":
      sta = "Nine"
      break
    default:
      break
  }
  await modalController.dismiss({ status: sta })
  pagesQueue.queuePageChange(sta)
}

// 返回 阅读理解 & AI智阅
// function backToSmartReading() {
//   modalController.dismiss({status: 'TO_ARTICLE'}).catch(e => console.log(e))
// }
//
// function requestGenerateForget(params: any) {
//   return new Promise((resolve: any, reject: any) => {
//     http.post("/forget/generateForget", params).then(async (res: any) => {
//       if (res.data.success) {
//         await alert("21天抗遗忘创建成功。");
//         resolve();
//       } else {
//         reject('')
//       }
//     });
//   });
// }

onBeforeMount(() => {
  storeData.value = store.getAppointment()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          class: "greeting-emoji_image",
          src: _unref(getBrandImageUrl)('speed/avatar_emoji.png'),
          alt: ""
        }, null, 8, _hoisted_4)
      ]),
      _createElementVNode("img", {
        class: "cheer-emoji",
        src: _unref(getBrandImageUrl)('speed/come_on_emoji.png'),
        alt: ""
      }, null, 8, _hoisted_5),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", null, [
          _cache[0] || (_cache[0] = _createElementVNode("span", { class: "state" }, "【正确】", -1)),
          _cache[1] || (_cache[1] = _createElementVNode("br", null, null, -1)),
          _createElementVNode("span", _hoisted_7, _toDisplayString(props.yesNum), 1)
        ]),
        _createElementVNode("div", null, [
          _cache[2] || (_cache[2] = _createElementVNode("span", { class: "state" }, "【错误】", -1)),
          _cache[3] || (_cache[3] = _createElementVNode("br", null, null, -1)),
          _createElementVNode("span", _hoisted_8, _toDisplayString(props.notNum), 1)
        ])
      ]),
      (storeData.value?.courseTypeId === 16)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "end",
            onClick: continuePractise
          }, [
            _createElementVNode("img", {
              src: _unref(getBrandImageUrl)('speed/end_exercise_button.png'),
              alt: ""
            }, null, 8, _hoisted_9),
            _cache[4] || (_cache[4] = _createElementVNode("span", { class: "end-text" }, "回到智阅", -1))
          ]))
        : _createCommentVNode("", true),
      (storeData.value?.courseTypeId === 3 || storeData.value?.courseTypeId === 4)
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: "end",
            onClick: continuePractise
          }, [
            _createElementVNode("img", {
              src: _unref(getBrandImageUrl)('speed/end_exercise_button.png'),
              alt: ""
            }, null, 8, _hoisted_10),
            _cache[5] || (_cache[5] = _createElementVNode("span", {
              class: "end-text",
              style: {"width":"100%"}
            }, "回到阅读理解", -1))
          ]))
        : _createCommentVNode("", true),
      (
          storeData.value?.courseTypeId !== 16 &&
          storeData.value?.courseTypeId !== 3 &&
          storeData.value?.courseTypeId !== 4
        )
        ? (_openBlock(), _createElementBlock("div", {
            key: 2,
            class: "end",
            onClick: endTheExercise
          }, [
            _createElementVNode("img", {
              src: _unref(getBrandImageUrl)('speed/end_exercise_button.png'),
              alt: ""
            }, null, 8, _hoisted_11),
            _createElementVNode("img", {
              class: "end-suffix",
              src: _unref(getBrandImageUrl)('speed/suffix_end_exercise_button.png'),
              alt: ""
            }, null, 8, _hoisted_12),
            _cache[6] || (_cache[6] = _createElementVNode("span", { class: "end-text" }, "结束练习", -1)),
            _cache[7] || (_cache[7] = _createElementVNode("span", { class: "end-suffix-text" }, "并创建抗遗忘", -1))
          ]))
        : _createCommentVNode("", true),
      (
          storeData.value?.courseTypeId !== 16 &&
          storeData.value?.courseTypeId !== 3 &&
          storeData.value?.courseTypeId !== 4
        )
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
            _createElementVNode("span", {
              class: "common-color",
              onClick: continuePractise
            }, "继续练习")
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})